
import SpecialDealSeeAll_ from '~/pages/_lang/special-deal/_url.vue'
export default SpecialDealSeeAll_
